export default {
    inserted(el, binding, vnode, old) {
        $(vnode.elm).tooltip()
    }
}